module.exports = __webpack_public_path__ + "img/start-3.9a75ec6d.png";